import React from "react";

const SumTable = ({ data }) => {



const transactions = data.transaction

// only the paid Transactions amount will be added to sum table
const transaction_amount = transactions.map((item) => item.status === 'Paid' ?  item.amount : 0);

const totaltransactionAmount = transaction_amount.reduce((accumulator, currentAmount) => {
  return parseInt(accumulator) + parseInt(currentAmount);
}, 0);


  return (
    <div className="">
      <div className="uk-width-1-1">
        <div className="analyticsTableWrp ">
          <table className="uk-table " style={{ marginBottom: 0 }}>
            <thead className="dropdownsum">
              <tr>
                  <th>Subtotal</th>
                  <th>Shipping</th>
                  <th>Grand total</th>
                  <th>Amount Paid</th>
                  <th>Amount Receivable</th>
              </tr>
            </thead>
            <tbody className="uk-light">




              <tr>

               {/* Intl NumerFormat for Formatting in PKR */}


              <td>Rs {new Intl.NumberFormat('en-PK', {
                              minimumFractionDigits: 0, 
                              maximumFractionDigits: 0
                              }).format(((parseInt(data.details.variant.colorComboPrice) || 0) + (parseInt(data.details.variant.variantPrice) || 0)))}</td>



                
              <td>Rs {new Intl.NumberFormat('en-PK', {
                              minimumFractionDigits: 0, 
                              maximumFractionDigits: 0
                              }).format((data.details?.vehicleDelivery?.freightCharges || 0))}</td>


                
              <td>Rs {new Intl.NumberFormat('en-PK', {
                              minimumFractionDigits: 0, 
                              maximumFractionDigits: 0
                              }).format(((parseInt(data.details.variant.colorComboPrice) + parseInt(data.details.variant.variantPrice) + parseInt((data.details?.vehicleDelivery?.freightCharges || 0) ) ) || 0))}</td>



                <td>Rs {new Intl.NumberFormat('en-PK', {
                              minimumFractionDigits: 0, 
                              maximumFractionDigits: 0
                              }).format((totaltransactionAmount || 0))}</td>



                <td>Rs {new Intl.NumberFormat('en-PK', {
                              minimumFractionDigits: 0, 
                              maximumFractionDigits: 0
                              }).format((((parseInt(data.details.variant.colorComboPrice) + 
                              parseInt(data.details.variant.variantPrice) + parseInt((data.details?.vehicleDelivery?.freightCharges || 0)) ) 
                              - totaltransactionAmount ) || 0))}</td>


                               
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SumTable;



